import { Grid } from "@mui/material"
import { Link } from "react-router-dom"
import { LandingActionCard } from "./LandingActionCard"
import { PageLayoutDefaultMenuNavigationLinkItem } from "@sis/react-library"

export interface LandingActionProps {
    menuItems: PageLayoutDefaultMenuNavigationLinkItem[],
    delay: number;
}

export const LandingAction = ({
    menuItems, delay
}: LandingActionProps) => {

    if (menuItems.length === 0) {
        return <></>
    }
    const { text, navigateTo } = menuItems[0];
    const id = `landing-action-${text.toLocaleLowerCase().replace(/\s/g, '-')}`;

    return (
        <Grid
            sx={{
                margin: '3% 4%',
                textAlign: 'center',
                width: '200px',
                '&:hover': {
                    transform: 'scale(1.05)',
                },
            }}
        >
            <Link
                style={{ textDecoration: 'none' }}
                to={navigateTo}
                id={id}
            >
                <LandingActionCard menuItems={menuItems} delay={delay} id={id} />
            </Link>
        </Grid>
    )
}
